// resources/js/i18n.js
import { createI18n } from 'vue-i18n';

// Cargar los archivos de traducción
import en from './locales/en.json';
import es from './locales/es.json';

// Crear la instancia de i18n
const i18n = createI18n({
  locale: 'es', // Idioma por defecto
  fallbackLocale: 'en', // Idioma alternativo si la traducción no se encuentra
  messages: {
    en,
    es
  }
});

export default i18n;
